module.exports = __webpack_public_path__ + "static/img/MaciunasGeorge_Politiken1963-1992_1_FPO.7a29dbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/MaciunasGeorge_Politiken1963-1992_1_FPO.jpg
// module id = F+rT
// module chunks = 0